import React, { useContext, useEffect, useState } from "react";
import './styles.css'
import { AiOutlineCheckCircle } from "react-icons/ai";
import { BiErrorCircle } from "react-icons/bi"
import { MessageContext } from "../../context/message";

function MessageGlobal(props) {
    const { setErrorMessage } = useContext(MessageContext);
    const [close, setclose] = useState(false)

    useEffect(() => {
        setTimeout(() => {
            setclose(true)
            setErrorMessage([])
        }, 6000);
        return () => {
            clearTimeout()
        }
    })

    function closeMessage() {
        setclose(!close)
    }

    return (
        <div key={props.myKey} className="message-global" style={{ display: close ? 'none' : 'block' }} >
            
            <div>
                {props.ok ? <AiOutlineCheckCircle color="green" size={30} /> : <BiErrorCircle color="red" size={30} />}
                <p>{props.text} </p>
                <button className="button-ms-close" onClick={() => closeMessage()}>X</button>
            </div>
            
        </div>
    )
}
export default MessageGlobal;